import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';

function JobDetail3() {
  return <>
    <Header />
    <section className="jobs">
    <div className="container">
        <div className="row">
            <div className="col-md-9">
                <p className="orange">Order Details</p>
                <div className="d-flex">
                    <div className=" justify-content-between">
                        <h5 className="blue">Beby Sitter Rerquired for 4-5 Hours. </h5>
                       
                    </div>
                    <div className="pl-5 mr-5 pt-2">
                        <p> JOB ID (CC12345)</p>
                    </div>
                    <div className="clearfix col-xs-12">
                        <a href="jobs-details-6.php" className="btn btn-white"><i className="fa fa-check-circle" aria-hidden="true"></i> Completed</a>
                    </div>
                </div>
                <div className="row panel-r align-middle align-items-center">
                    <div className="col-md-3">
                        <ul className="list-unstyled friend-list border-bottom border">
                            <li className="active grey lighten-3  pl-1 pr-1">
                                <a href="#" className="d-flex pt-2 justify-content-between">
                                    <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg" width="50"
                                        height="50" className="rounded-circle" alt="avatar"
                                        className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1" />

                                    <div className="text-small">
                                        <strong>John Doe</strong>
                                        <p className="last-message text-muted "><span className="orange">Senior Care</span>

                                        </p>
                                    </div>
                                    <div className="chat-footer pt-2">
                                        <p className="text-smaller text-muted mb-0"><i className="fa fa-star"></i> 4.5</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-2 py-1">
                        <span><i className="fa fa-dollar"></i> <b>$100</b> (2 Hours) </span>
                    </div>
                    <div className="col-md-2 py-1">
                        <span><i className="fa fa-calendar"></i> 28 Aug 2021</span>
                    </div>
                    <div className="col-md-2 py-1">
                        <span><i className="fa fa-clock-o"></i> 05 :30 PM </span>
                    </div>
                    <div className="col-md-2 text-right py-1">
                    <span className="p-13"><i className="fa fa-exclamation"></i> <span className="blue p-14">Job Completed</span></span> 
                    </div>
                </div>
            <div className="row bot-p">
                <div className="col-md-7">
                <p className="p-13"> <i className="fa fa-map-marker orange"></i> 10515 Fox Ave Fairdale, Kentucky(KY), 40118 TX | USA <span className="p-13"><a href="#">View on Map</a></span></p>  
                </div>    
                <div className="col-md-5 justify-content-right">
            <p className="justify-content-right p-13 text-right"> Time Remaining <span><a href="#" className="orange ">1 Days | 05 Hours | 57 Mins</a></span></p> 
                </div>              
            </div>
           <hr />
           
                <div className="">
                   <h5 className="blue">Beby Sitter Rerquired for 4-5 Hours. </h5>
                   <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                et dolore magna aliqua. .
            </p>
                </div>
           

                <div className="card rare-wind-gradient chat-room">
                        <div className="chat-message">
                            <ul className="list-unstyled chat-1 scrollbar-light-blue">
                            <li className="d-flex  justify-content-left mb-4">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar" 
                                    className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1" />
                                <div className="chat-body white p-3 ml-2 z-depth-1">
                                    <p className="mb-0">
                                        Lorem ipsum dolor sit amet,
                                    </p>
                                    <div className="header">
                                        <strong className="primary-font">Brad Pitt</strong>
                                        <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins
                                            ago</small>
                                    </div>
                                </div>
                            </li>
                            <li className="d-flex justify-content-end mb-4">
                                <div className="chat-body white p-3 z-depth-1">

                                    <p className="mb-0 text-white blue-back">
                                        Sed ut perspiciatis unde omnis iste natus error
                                    </p>
                                    <div className="header ">
                                        <strong className="primary-font">Lara Croft</strong>
                                        <small className="pull-right text-muted"><i className="far fa-clock"></i> 13 mins
                                            ago</small>
                                    </div>
                                </div>
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar" 
                                className="avatar rounded-circle mr-0 ml-3 z-depth-1" />
                            </li>
                            <li className="d-flex  justify-content-left mb-4">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar" 
                                    className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1" />
                                <div className="chat-body white p-3 ml-2 z-depth-1">
                                    <p className="mb-0">
                                        Lorem ipsum dolor sit amet,
                                    </p>
                                    <div className="header">
                                        <strong className="primary-font">Brad Pitt</strong>
                                        <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins
                                            ago</small>
                                    </div>
                                </div>
                            </li>
                            <li className="d-flex justify-content-end mb-4">
                                <div className="chat-body white p-3 z-depth-1">

                                    <p className="mb-0 text-white blue-back">
                                        Sed ut perspiciatis unde omnis iste natus error
                                    </p>
                                    <div className="header ">
                                        <strong className="primary-font">Lara Croft</strong>
                                        <small className="pull-right text-muted"><i className="far fa-clock"></i> 13 mins
                                            ago</small>
                                    </div>
                                </div>
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar" 
                                    className="avatar rounded-circle mr-0 ml-3 z-depth-1" />
                            </li>
                            <li className="d-flex  justify-content-left mb-4">
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" 
                                    alt="avatar" className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1" />
                                <div className="chat-body white p-3 ml-2 z-depth-1">
                                    <p className="mb-0">
                                        Lorem ipsum dolor sit amet,
                                    </p>
                                    <div className="header">
                                        <strong className="primary-font">Brad Pitt</strong>
                                        <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins
                                            ago</small>
                                    </div>
                                </div>
                            </li>
                            <li className="d-flex justify-content-end mb-4">
                                <div className="chat-body white p-3 z-depth-1">
                                    <p className="mb-0 text-white blue-back">
                                        Sed ut perspiciatis unde omnis iste natus error
                                    </p>
                                    <div className="header ">
                                        <strong className="primary-font">Lara Croft</strong>
                                        <small className="pull-right text-muted"><i className="far fa-clock"></i> 13 mins
                                            ago</small>
                                    </div>
                                </div>
                                <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" 
                                    alt="avatar" className="avatar rounded-circle mr-0 ml-3 z-depth-1" />
                            </li>

                        </ul>
                        <div className="white">
                            <div className="d-flex justify-content-start">
                                <div className="form-group basic-textarea col-md-11 col-xs-12 col-sm-12">
                                    <textarea className="form-control pl-2 my-0" id="exampleFormControlTextarea2" rows="3" placeholder="Type your message here..."></textarea>
                                </div>


                                <div className="justify-content-end col-md-1 col-xs-12 col-sm-12">
                                <div className="input-group-append">
                                <button className="input-group-text  btn-danger amber lighten-3 border-0 " id="basic-text1">
                                        <img src="img/send.png" height="18" className="white" /></button>
                                </div>
                                </div>
                            </div>
                        </div>

                        </div>
                </div>



                    </div>

            <div className="col-sm-6 col-lg-3 m-15 px-tb overfl">
                            <div className="job-item  box-shadow-only-hover hover-top border-all-1 border-color-gray py-3 border">
                                <div className="item-overlay ">
                                    <div className="job-info text-center align-self-center">
                                        <img  src="https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg" className="text-center rounded-circle align-self-center" alt="" />
                                        <div className="text-center py-3">
                                            <h5><a href="#" className="grey">Consectetur</a></h5>
                                            <h6><a className="orange" href="#">Bubbles Studios</a></h6>
                                            <h6>Member since - Jan 2018</h6>
                                        </div>
                                        <div>
                                        </div>
                                        
                                    </div>
                                    <ul className="tr-list job-meta list-unstyled job-social tr-list text-center">
                                        <li><i className="fa fa-map-marker orange" aria-hidden="true"></i> Manchester, England
                                        </li>
                                        <li><i className="fa fa-money orange" aria-hidden="true"></i> $ 2,000 - $ 2,500</li>
                                        
                                        <br /><li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>
                                    </ul>

                                   
                                </div>
                            </div>
                        </div>

        </div>
        </div>
        </section>
    <Footer />
  </>;
}

export default JobDetail3;
